// removed by extract-text-webpack-plugin
module.exports = {"apps-container":"apps-container","app-card":"app-card","app-icon":"app-icon","app-pgs":"app-pgs","app-pgd":"app-pgd","app-azf":"app-azf","app-name":"app-name","card-shadow":"card-shadow","azf":"azf","pgd":"pgd","pgs":"pgs"};


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/apps/Index.scss
// module id = 934
// module chunks = 0